import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();

  openCookieSettings(): void {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('dotblack-open-cookie-settings'));
    }
  }
}